<template>
    <div class="card_container">
        <van-row class="card_data">
            <van-col span="12">
                <div class="title_text">{{ $t('common.deposite') }} <span><span class="currencyIcon">R$</span> {{
                    Number(props.cardData.recharge)
                        }}</span></div>
                <div class="title_text">{{ $t('offers.win') }} <span><span class="currencyIcon">R$</span> {{
                    Number(props.cardData.reward) }}</span>
                </div>
            </van-col>
            <van-col span="12" class="right_cell">
                <div class="right_text"><span>{{ Number(props.cardData.recharge) +
                    Number(props.cardData.reward) }}</span></div>
                <div class="right_text">{{ $t('offers.totaling') }}(R$)</div>
            </van-col>
            <van-col span="6" offset="18" class="deposit_btn">
                <van-button size="small" @click="handleDeposit">{{ $t('common.deposite') }}</van-button>
            </van-col>
            <van-col span="24" class="bottom_text">
                <div>{{ $t('offers.demanding') }} R$ {{ Number(props.cardData.turnover) }} {{
                    $t('offers.rollover') }}</div>
            </van-col>
        </van-row>
    </div>
    <InfoPoup ref="infoPopupRef" />
    <DepositPopup ref="depositpopupRef" />
</template>
<script setup lang="ts">
import { ref } from 'vue';
import InfoPoup from './infoPoup.vue';
import DepositPopup from './depositPopup.vue';

const infoPopupRef = ref()
const depositpopupRef = ref()
const props = defineProps({
    cardData: {
        type: Object,
        required: true
    },
    isActivityEnable: {
        type: Boolean,
        default: false
    },
    dayName: {
        type: String,
    }
})
const handleDeposit = () => {
    if (props.isActivityEnable) {
        depositpopupRef.value.open(props.cardData)
    } else {
        infoPopupRef.value.open(props.dayName)
    }
}
</script>
<style scoped>
.card_container img {
    width: 100%;
    margin-bottom: 2vw;
    display: block;
}

.card_container {
    width: 100%;
    margin-bottom: 2vw;
    color: rgb(255,255,255,0.4);
    font-weight: 500;
    font-size: 14px;

}

.card_data {
    border-radius: 20px;
    border: 3px solid rgb(13, 176, 174);
    background-image: linear-gradient(90deg, rgb(0, 86, 85) 0%, rgb(0, 20, 20) 124%);
    box-shadow: 0 0 6.1px 0 rgba(255, 255, 255, 0.4),0 0 75px 0 rgba(5, 122, 120, 0.39) inset;
    padding: 10px 15px;
    
}

.currencyIcon {
    font-size: 11px;
}

.title_text {
    color: var(--ep-color-text-default, #FFF);
    font-weight: 600;
    text-shadow: 0px 0px 9px rgba(159, 88, 252, .43);
    font-size: 13px;
    padding: 2.5px;
}

.title_text span {
    color: rgb(245, 200, 76);
}

.right_cell {
    text-align: right;
}

.right_text {
    font-size: 12px;
}

.right_text span {
    font-size: 18px;
    color: rgb(245, 200, 76);
    font-weight: bold;
}

.deposit_btn {
    display: flex;
    justify-content: center;
    margin-top: 5px;
}

.deposit_btn>>>.van-button--small {
    padding: 5px 10px;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 600;
    border-radius: .5rem;
    background: linear-gradient(90deg, rgb(2, 74, 73) 0%, rgb(13, 176, 174) 100%) !important;
    box-shadow: 0 0 .4688rem rgba(244, 40, 237, .25);
    color: #fff;
    height: 25px;
    border: unset;
    /* background: #fed700;
    border: .02667rem solid #fed700;
    border-radius: 5px;
    color: #604029;
    width: 75%;
    margin-left: 10px;
    margin-top: 5px;
    font-size: 13px !important; */
}

.bottom_text {
    padding-left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 1%;
    font-size: 12px;
}

@media (min-width: 400px) {

    .title_text {
        font-size: 16px;
    }

    .right_text {
        font-size: 14px;
    }

    .right_text span {
        font-size: 18px;
    }

    .card_container img {
        margin-bottom: 10px !important;
    }

    .deposit_btn>>>.van-button--small {
        font-size: 15px !important;
    }
}
</style>